<template>
  <div>
    <LoadingSpinner v-if="loading2 || loadingChangePrimary" />
    <section class="billing-summary" v-if="!loading2">
      <div
        v-show="!loadingChangePrimary"
        class="transactions payment-methods animated fadeIn fast"
      >
        <div class="contenedor">
          <div class="row">
            <div class="col-6">
              <h5 class="font-weight-bold">
                {{ $t("lang.label.paymentmethods") }}
              </h5>
            </div>

            <!-- Botones de tipo de forma de pago. credit/debito o Debito directo -->
            <div class="col-6 d-flex justify-content-end">
              <button
                v-if="paymentMethods && paymentMethods.length"
                class="btn btn-sm btn-primary themed-button mr-3"
                @click="openModal('changePrimaryPaymentMethod')"
              >
                {{ $t("lang.payment.title_change_payment_method") }}
              </button>

              <button
                class="btn btn-sm btn-primary themed-button"
                :disabled="btnMethods.creditCard.disabled"
                @click="showMethods('creditCard')"
                type="submit"
              >
                <span class="btn-width" v-if="btnMethods.creditCard.loading">
                  <Loadingcircle :paramloading="paramloading" />
                </span>
                <span v-else>
                  <span class="icon-credit-card mx-1"></span>
                  {{ $t("lang.label.credit_debit") }}
                </span>
              </button>

              <button
                class="ml-3 btn btn-sm btn-primary
                themed-button"
                :disabled="btnMethods.sepa.disabled"
                @click="openModal('sepaPaymentMethod')"
                type="submit">
                  <span class="btn-width" v-if="btnMethods.sepa.loading">
                    <Loadingcircle :paramloading="paramloading" />
                  </span>
                  <span v-else>
                    <span class="icon-bank mx-1 "></span>
                    {{ $t("lang.label.direct_debit") }}
                  </span>
              </button>
            </div>
          </div>
          <div class="row">
            <div
              class="col-md-6 col-sm-12 pr-4"
              v-for="(payment, key) in paymentMethods"
              :key="key"
            >
              <div
                class="card mt-3 cursor-pointer"
              >
                <span style="position: absolute; top: 6px; left: 7px; font-size: 0.6rem;">{{ payment.creation_date }}</span>
                <span v-if="payment.payment_type == 'sepa'" style="position: absolute; top: 20px; left: 7px; font-size: 0.6rem;"><img width="30px" src="@/assets/images/sepa.png"></span>
                <div class="pr-2 pt-1">
                  <div v-if="payment.payment_type != 'sepa'">
                    <span
                      class="mt-3 ml-4"
                    v-if="hasDeclinedPayments && payment.default"
                    >
                      {{ $t("lang.payment.lastfailed") }}
                      <span
                        class="btn btn-info btn-sm ml-2"
                        @click.stop="chargePendingPayments()"
                        >{{ $t("lang.payment.fixitnow") }}</span
                      >
                    </span>
                  </div>
                  <button
                    v-if="payment.default != '1'"
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                    @click="deletePaymentMethod(payment)"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="body p-3">
                  <div
                    class="table-responsive table-transactions"
                    :class="payment.default === '1' ? 'title' : ''"
                  >
                    <div v-if="payment.payment_type == 'cc'">
                      <div class="d-flex justify-content-between mb-1">
                        <span style="font-size: 0.8rem;">Brand</span>
                         <img width="30px" :src="typeBrand(payment.brand)" />
                      </div>
                      <div class="d-flex justify-content-between mb-1">
                        <span style="font-size: 0.8rem;">Card Number</span>
                        <span class="font-weight-bold">{{ payment.card_number }}</span>
                      </div>
                      <div class="d-flex justify-content-between mb-1">
                        <span style="font-size: 0.8rem;">Card Owner</span>
                        <span class="font-weight-bold">{{ payment.name_on_card }}</span>
                      </div>
                      <div class="d-flex justify-content-between mb-1" v-if="payment.expiration_year != null || payment.expiration_month != null">
                        <span style="font-size: 0.8rem;">Expiration Date</span>
                        <span class="font-weight-bold">{{ payment.expiration_month }} / {{ payment.expiration_year }}</span>
                      </div>
                    </div>
                    <div v-else>
                      <div class="d-flex justify-content-between mb-1">
                        <span style="font-size: 0.8rem;">ID SEPA Number</span>
                        <span class="font-weight-bold">EDI{{ String(payment.id).padStart(10, '0') }}</span>
                      </div>
                      <div class="d-flex justify-content-between mb-1">
                        <span style="font-size: 0.8rem;">Bank Account</span>
                        <span class="font-weight-bold">{{ payment.bank_account_name }}</span>
                      </div>
                      <div class="d-flex justify-content-between mb-1">
                        <span style="font-size: 0.8rem;">IBAN</span>
                        <span class="font-weight-bold">{{ payment.iban }}</span>
                      </div>
                      <div class="d-flex justify-content-between mb-1">
                        <span style="font-size: 0.8rem;">SWIFT BIC</span>
                        <span class="font-weight-bold">{{ payment.swift_bic }}</span>
                      </div>
                      <div class="d-flex justify-content-between mb-1">
                        <span style="font-size: 0.8rem;">Adress Line (1)</span>
                        <span class="font-weight-bold">{{ payment.address_line_1 }}</span>
                      </div>
                      <div class="d-flex justify-content-between mb-1" v-if="payment.address_line_2 != null">
                        <span style="font-size: 0.8rem;">Adress Line (2)</span>
                        <span class="font-weight-bold">{{ payment.address_line_2 }}</span>
                      </div>
                      <div class="d-flex justify-content-between mb-1" v-if="payment.signtory_name != null">
                        <span style="font-size: 0.8rem;">Signatory Name</span>
                        <span class="font-weight-bold">{{ payment.signatory_name }}</span>
                      </div>
                      <div class="d-flex justify-content-between mb-1">
                        <span style="font-size: 0.8rem;">Postal Code</span>
                        <span class="font-weight-bold">{{ payment.postal_code }}</span>
                      </div>
                      <div class="d-flex justify-content-between mb-1">
                        <span style="font-size: 0.8rem;">City</span>
                        <span class="font-weight-bold">{{ payment.city }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="payment.payment_type == 'sepa'" class="mt-2 float-left">
                    <button class="btn btn-success btn-sm" @click="downloadMandatSepa(payment.id)">Mandat SEPA <i class="icon-download ml-1"></i></button>
                  </div>
                  <div v-if="payment.default === '1'" class="mt-2 float-right">
                    <small class="badge badge-primary">PRIMARY</small>
                  </div>
                  <div class="mt-2 float-right">
                    <small
                      v-if="payment.expired === '0'"
                      class="badge btn-success mr-3"
                      >VALID</small
                    >
                    <small
                      v-if="payment.expired === '1'"
                      class="badge btn-warning mr-3"
                      >EXPIRES SOON</small
                    >
                    <small
                      v-if="payment.expired === '2'"
                      class="badge btn-danger mr-3"
                      >EXPIRED</small
                    >
                  </div>
                </div>
              </div>
            </div>
            <LoadingSpinner v-if="loading" />
          </div>
        </div>
        <!--//contenedor-->
      </div>
      <Modal :name="'sepaPaymentMethod'" height="60%" width="60%" :max-width="800">
        <BankAccountForm :anonymousType="false"></BankAccountForm>
      </Modal>
      <Modal :name="'changePrimaryPaymentMethod'" height="55%" width="60%" :max-width="800">
        <div class="p-2">
          <ChangeClientPaymentMethod
            :paymentMethods="paymentMethods"
            @cancel="closeModal('changePrimaryPaymentMethod')"
            @change-primary-loading="setChangePrimaryLoading"
            @change-primary-done="onChangePrimaryPaymentDone"
          />
        </div>
      </Modal>
    </section>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import { mapState, mapActions } from "vuex";
import { billingsService, campaignsService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import BankAccountForm from "@/components/Billing/BankAccountForm.vue";
import CreditCardForm from "@/components/Billing/CreditCardForm.vue";
import ChangeClientPaymentMethod from "@/components/Billing/ChangeClientPaymentMethod.vue";
import Loadingcircle from "@/components/Common/Loadingcircle.vue";
import { formattersMixin, campaignUtilsMixin, billingUtilsMixin } from "@/_mixins/";
import $ from "jquery";

export default {
  props: {
    subscriptionData: Object,
    validProfile: Boolean,
  },
  data() {
    return {
      paramloading: {
        width: "22px",
        height: "22px",
        color: "#fff",
      },
      btnMethods: {
        sepa: {
          loading: false,
          disabled: false,
        },
        creditCard: {
          loading: false,
          disabled: false,
        },
      },
      alertMethod: false,
      currency: "",
      addNewMethod: false,
      newMethodType: "",
      method: {},
      isCollapseOneSelected: false,
      isCollapseTwoSelected: false,
      loading2: false,
      loadingChangePrimary: false,
    };
  },
  components: {
    Header,
    LoadingSpinner,
    BankAccountForm,
    CreditCardForm,
    Loadingcircle,
    ChangeClientPaymentMethod,
  },

  mixins: [formattersMixin, billingUtilsMixin],

  created() {
    if (
      this.user.subscription_status_id != 1 &&
      !this.subscriptionData.plan_id &&
      !this.hasDeclinedPayments
    ) {
      this.$router.push("/upgrade");
    }
    this.getData();
    if (this.$route.query.payment) {
      this.addNewMethod = true;
      setTimeout(() => {
        $("#credit-card-button").trigger("click");
      }, 2000);
    }
  },
  computed: {
    ...mapState({
      plans: (state) => state.plans.all,
      activePlans: (state) => state.plans.allActives,
      paymentMethods: (state) => state.billings.all.data,
      loading: (state) => state.billings.loading,
    }),
    newPaymentBankMethod() {
      return "BankAccountForm";
    },
    newPaymentCardMethod() {
      return "CreditCardForm";
    },
    selectedMethod() {
      return this.method;
    },
    user() {
      return this.$store.state.authentication.user;
    },
    hasDeclinedPayments() {
      return (
        this.$store.state.authentication.toastNotificationData
          .hasDeclinedPayments.length > 0
      );
    },
  },
  methods: {
    ...mapActions("billings", {
      startLoading: "startLoading",
      finishLoading: "finishLoading",
      getAllPaymentMethods: "getAll",
    }),
    ...mapActions("plans", {
      getAllPlans: "getAll",
    }),

    typeBrand(payment)
    {
      switch(payment){
        case "Visa":
          {
            return require("@/assets/images/visa-logo.png");
          }
        case "CB":
          {
            return require("@/assets/images/cb-logo.png");
          }
        case "Mastercard":
          {
            return require("@/assets/images/mc-logo.png");
          }
      }
    },
    getData() {
      this.getAllPaymentMethods();
      this.getCurrency();
    },
    downloadMandatSepa(id){
      billingsService.downloadMandatSepa(id).then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Mandat_SEPA_Oliverlist_${id}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      });
    },
    /*getPaymentMethods(){
                billingsService.getPaymentMethods().then(result => {
                     this.paymentMethods = result;
                     this.shAlert( this.paymentMethods);
                }).then(result =>
                    this.loading = false
                );
            },
            shAlert(arr){
                 if( arr.length === 0){
                    this.alertMethod=true
                    } else{ this.alertMethod=false}
            },*/
    getCurrency() {
      this.currency = "€";
    },
    showMethods(payMethod) {
      this.btnMethods.sepa.disabled = true;
      this.btnMethods.creditCard.disabled = true;
      this.btnMethods[payMethod].loading = true;

      /*
      //INGENICO
      this.addNewMethod = true;
      this.isCollapseOneSelected = false;
      this.isCollapseTwoSelected = false;*/

      let data = Object.assign({});

      if (payMethod === "sepa") {
        data.payment_method_type = "gocardless";
      }
      data.url = this.$route.path;
      billingsService.saveSepaPaymentMethod(data).then((response) => {
        this.finishLoading();
        if (response.orderCode !== undefined) {
          window.location.href = response.orderCode;
          return;
        } 
        else {
        this.$swal({
          type: "error",
          title: this.$t("lang.label.error"),
          text: 'ERROR',
          showConfirmButton: true,
        });
          return;
        }
      });
    },

    addNewPaymentMethod() {
      if (this.newMethodType == "bank") {
        this.isCollapseOneSelected = true;
        this.isCollapseTwoSelected = false;
        this.method = {
          bank_account_name: "",
          iban: "",
          swift_bic: "",
          signtory_name: "",
          address_line_1: "",
          address_line_2: "",
          postal_code: "",
          city: "",
          default: 1,
        };
      } else {
        this.isCollapseOneSelected = false;
        //   this.isCollapseTwoSelected = true;
        this.isCollapseTwoSelected = false;
        this.method = {
          name_on_card: "",
          card_number: "",
          brand: "",
          expiration_month: "",
          expiration_year: "",
          default: 1,
        };
      }
    },
    newPaymentMethod(method) {
      this.newMethodType = method;
      this.addNewPaymentMethod();
    },
    closeNewPaymentMethod() {
      this.addNewMethod = false;
    },
    refreshPaymentMethods(refreshToken) {
      this.closeNewPaymentMethod();
      this.getAllPaymentMethods();
      if (refreshToken != undefined) {
        const { dispatch } = this.$store;
        dispatch("authentication/refreshToken");
      }
    },
    openModal(modalId) {
      this.$modal.show(modalId);
    },
    closeModal(modalId) {
      this.$modal.hide(modalId);
    },
    setChangePrimaryLoading(isLoading) {
      this.loadingChangePrimary = isLoading;
    },
    onChangePrimaryPaymentDone({ success }) {
      if (success) {
        this.closeModal("changePrimaryPaymentMethod");
        window.location.reload();
      }
    },
    deletePaymentMethod(payment) {
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousureyouwanttodeletethispaymentmethod"),
        text: "",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonColor: "#d33a2c",
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.value) {
          if (this.paymentMethods.length > 1) {
            if (payment.isDefault == 1) {
              this.$swal({
                type: "error",
                title: this.$t("lang.label.error"),
                text: this.$t(
                  "lang.label.youneedtochooseanotherprimarypaymentmethodifyouwanttodeletethispaymentmethod"
                ),
                showConfirmButton: true,
              });
            } else {
              billingsService
                .deletePaymentMethod(payment.id, payment.payment_type)
                .then((response) => {
                  this.$swal({
                    type: "success",
                    title: this.$t("lang.label.great"),
                    text: this.$t(
                      "lang.label.paymentmethoddeletedsuccessfully"
                    ),
                    showConfirmButton: false,
                    timer: 3000,
                  });
                })
                .then((response) => {
                  this.refreshPaymentMethods();
                });
            }
          } else {
            this.$swal({
              type: "error",
              title: this.$t("lang.label.error"),
              text: this.$t(
                "lang.label.youmustaddanewvalidpaymentmethodbeforedeletingthispaymentmethod"
              ),
              showConfirmButton: true,
            });
          }
        }
      });
    }, // deletePaymentMethod

    chargePendingPayments() {
      this.$swal({
        type: "warning",
        title: this.$t("lang.payment.chargeattempt"),
        text: this.$t("lang.payment.chargeattemptinfo"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonColor: "#d33a2c",
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.value) {
          this.loading2 = true;
          billingsService.chargePendingPayments(0).then(
            (response) => {
              const { dispatch } = this.$store;
              dispatch("authentication/getToastNotificationData").then(() => {
                this.loading2 = false;
                this.showChargePendingResultSwal(response);
              });
            },
            (error) => {
              this.loading2 = false;
              const { dispatch } = this.$store;
              dispatch("authentication/getToastNotificationData").finally(() => {
                this.showChargePendingResultSwal(error);
              });
            }
          );
        }
      });
    }, // chargePendingPayments
  },
};
</script>
<style>
.card .body.p-4 {
  min-height: 150px;
}
.accordion > .card:first-of-type {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125) !important;
}
.payment-methods .btn-link {
  color: #212529;
}
.payment-methods .btn-link:hover {
  color: #101113;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.badge.plan {
  background: #5054EB;
}
.btn-width {
  width: 100px;
}
</style>
